import AICheckPage from "@/views/ai/h_check_page.vue";

export interface MenuItem {
    path?: string;
    name: string;
    icon: string;
    isExternal?: boolean;
    externalUrl?: string;
}

export const menuItems: MenuItem[] = [
    {
        path: '/',
        name: '订单查询',
        icon: 'Wallet'
    },
    {
        path: '/ai',
        name: '电话反馈',
        icon: "Phone"
    },
    {
        path: '/statistic',
        name: '统计',
        icon: 'BarChart3'
    },
    {
        path: '/app',
        name: 'APP反馈',
        icon: 'Smartphone'
    },
    {
        name: 'APP兑换',
        path: '/recode',
        icon: 'Link',
        isExternal: true,
        externalUrl: 'https://starry.17xiudou.cn/h5/record/'
    },
];

export const handleExternalLink = (url: string) => {
    window.open(url, '_self');
};
